import { today } from './when'

export function validDay(value) {
  if (typeof value !== 'string' || !/^(19|20|21)\d{2}-\d{2}-\d{2}$/.test(value)) return ''
  const parts = value.split('-').map(Number)
  const date = new Date(parts[0], parts[1] - 1, parts[2])
  return date.getFullYear() === parts[0] &&
    date.getMonth() === parts[1] - 1 &&
    date.getDate() === parts[2]
    ? value
    : ''
}
export function scheduleType(value) {
  return ['follow', 'visit'].indexOf(value) >= 0 ? value : 'all'
}
export function scheduleLocation(date, type) {
  return { path: '/schedule', query: { date: validDay(date) || today(), type: scheduleType(type) } }
}



// WEBPACK FOOTER //
// ./src/common/schedule.js